
import _, { groupBy } from "lodash";
import deepdash from "deepdash";

deepdash(_);
export const clone = (obj) => (JSON.parse(JSON.stringify(obj)));

export const convertLanguageCode = (value) => {
    let fullCode = value;
    
    let split = fullCode.split('-')[1];
    // let result = split.charAt(0) + split.charAt(1).toLowerCase();
    return split;
}
export const rpad2D = (list, cols, initialData) => {
    var result = new Array(Math.ceil(list.length / cols));
    for (var i = 0; i < result.length; i++) {
        result[i] = new Array();
        for (var j = 0; j < cols; j++) {
            if (initialData) {
                result[i][j] = initialData;
            } else {
                result[i][j] = {};
            }

        }
    }
    for (var i = 0; i < list.length; i++) {
        result[parseInt(i / cols)][i % cols] = list[i];
    }

    return result;
}

export const getCurrentLanguageCode = () => {
    let fullCode = getLocalStorage("i18nextLng");
    let split = fullCode.split('-')[1];
    if (split) {
        let result = split.charAt(0) + split.charAt(1).toLowerCase();
        return result;
    }


}

export const getLocalStorage = (key) => {
    return window.localStorage.getItem(key);
};

export const validateInputs = async (inputs) => {
    return new Promise(async (resolve, reject) => {
        let result = true;
        let index = 0;
        
        for (let i = 0; i < inputs.length; i++) {
            index = i;
            let input = inputs[i];
            
            let validateFn = input.isValid;
            
            // validateFn이 정의되지 않은 경우 기본적으로 유효한 것으로 간주
            if (validateFn !== undefined && validateFn !== null) {
                let isAsyncFn = validateFn.constructor.name === "AsyncFunction";
                let isValid = false;
                
                if (isAsyncFn) {
                    await validateFn().then((validationResult) => {
                        isValid = validationResult;
                    }).catch(() => {
                        isValid = false;
                    });
                } else {
                    try {
                        isValid = validateFn();
                    } catch {
                        isValid = false;
                    }
                }

                if (!isValid) {
                    input.focus();
                    result = false;
                    break;
                }
            } else {
                // validateFn이 정의되지 않은 경우 기본적으로 유효하다고 간주
                continue;
            }
        }
        resolve({ isValid: result, index: index });
    });
}